import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ProjectMemberController::store
* @see Http/Controllers/ProjectMemberController.php:21
* @route '/projects/{project}/members'
*/
export const store = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/projects/{project}/members',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ProjectMemberController::store
* @see Http/Controllers/ProjectMemberController.php:21
* @route '/projects/{project}/members'
*/
store.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return store.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectMemberController::store
* @see Http/Controllers/ProjectMemberController.php:21
* @route '/projects/{project}/members'
*/
store.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectMemberController::store
* @see Http/Controllers/ProjectMemberController.php:21
* @route '/projects/{project}/members'
*/
const storeForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectMemberController::store
* @see Http/Controllers/ProjectMemberController.php:21
* @route '/projects/{project}/members'
*/
storeForm.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\ProjectMemberController::update
* @see Http/Controllers/ProjectMemberController.php:45
* @route '/projects/{project}/members/{projectMember}'
*/
export const update = (args: { project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } } | [project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/projects/{project}/members/{projectMember}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ProjectMemberController::update
* @see Http/Controllers/ProjectMemberController.php:45
* @route '/projects/{project}/members/{projectMember}'
*/
update.url = (args: { project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } } | [project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            projectMember: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        projectMember: typeof args.projectMember === 'object'
        ? args.projectMember.id
        : args.projectMember,
    }

    return update.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{projectMember}', parsedArgs.projectMember.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectMemberController::update
* @see Http/Controllers/ProjectMemberController.php:45
* @route '/projects/{project}/members/{projectMember}'
*/
update.patch = (args: { project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } } | [project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\ProjectMemberController::update
* @see Http/Controllers/ProjectMemberController.php:45
* @route '/projects/{project}/members/{projectMember}'
*/
const updateForm = (args: { project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } } | [project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectMemberController::update
* @see Http/Controllers/ProjectMemberController.php:45
* @route '/projects/{project}/members/{projectMember}'
*/
updateForm.patch = (args: { project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } } | [project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\ProjectMemberController::destroy
* @see Http/Controllers/ProjectMemberController.php:62
* @route '/projects/{project}/members/{projectMember}'
*/
export const destroy = (args: { project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } } | [project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/projects/{project}/members/{projectMember}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ProjectMemberController::destroy
* @see Http/Controllers/ProjectMemberController.php:62
* @route '/projects/{project}/members/{projectMember}'
*/
destroy.url = (args: { project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } } | [project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            projectMember: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        projectMember: typeof args.projectMember === 'object'
        ? args.projectMember.id
        : args.projectMember,
    }

    return destroy.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{projectMember}', parsedArgs.projectMember.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectMemberController::destroy
* @see Http/Controllers/ProjectMemberController.php:62
* @route '/projects/{project}/members/{projectMember}'
*/
destroy.delete = (args: { project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } } | [project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ProjectMemberController::destroy
* @see Http/Controllers/ProjectMemberController.php:62
* @route '/projects/{project}/members/{projectMember}'
*/
const destroyForm = (args: { project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } } | [project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectMemberController::destroy
* @see Http/Controllers/ProjectMemberController.php:62
* @route '/projects/{project}/members/{projectMember}'
*/
destroyForm.delete = (args: { project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } } | [project: string | number | { id: string | number }, projectMember: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const ProjectMemberController = { store, update, destroy }

export default ProjectMemberController